<template>
  <section>
    <v-row>
      <v-col cols="12" md="8">
        <v-subheader>Aircraft Info</v-subheader>
        <v-data-table class="no-footer-table" :headers="headers" :items="plain_logs" :items-per-page="30" flat>
          <template v-slot:item.oil="{ item }">
            <span v-if="item.oil">{{ item.oil }} qts</span></template>
          <template v-slot:item.fuel="{ item }">
            <span v-if="item.fuel">{{ item.fuel }} gal</span></template>
          <template v-slot:item.actions="{ item }">
            <v-btn class="blue--text" v-if="!item.logID" icon small @click="logInfo(item)">
              <v-icon left>mdi-clipboard-edit-outline</v-icon></v-btn>
            <v-btn class="blue--text" v-else icon small @click="edit(item)">
              <v-icon center>mdi-clipboard-edit</v-icon></v-btn>
          </template>
        </v-data-table>

      </v-col>
      <v-col cols="12" md="4">


        <v-data-table :items="resources" class="no-footer-table" :headers="stockHeaders" flat>

          <template v-slot:item.actions="{ item }">
            <v-btn @click="addResources(item)" color="blue" icon small>
              <v-icon center>mdi-plus</v-icon>
            </v-btn>
          </template>

          <template v-slot:item.qty="{ item }">

            {{ item.qty }} {{ item.unit }}

          </template>

        </v-data-table>



        <!-- <v-list class="stock">
                    
                      <v-subheader>Stock</v-subheader>
                      <v-list-item 
                        v-for="r in resources"
                        :key="r.id"
                      >
                        <v-list-item-content>
                           {{r.name}}: {{r.qty}} {{r.unit}}
                         <v-btn color="blue" icon small> 
                          <v-icon center>mdi-plus</v-icon>
                        </v-btn>
                      </v-list-item-content>
                      </v-list-item>
                </v-list> -->


      </v-col>

    </v-row>

    <v-dialog v-model="dialog" @keydown.esc="dialog = false" persistent max-width="600px">
      <v-form ref="form" v-model="valid" @submit.prevent="save">
        <v-card color="lighten-1">

          <v-toolbar>
            <v-toolbar-title>
              <span class="headline">{{ formTitle }}</span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <fieldset class="inline-form input-4">
              <v-text-field label="Hobbs" v-model="editedItem.hobbs" type="number"></v-text-field>
              <v-text-field label="Tachtime" v-model="editedItem.tachtime" type="number"></v-text-field>
              <v-text-field :disabled="editedIndex > -1 || !viewingToday" label="Oil" v-model="editedItem.oil"
                type="number" suffix="qts"></v-text-field>
              <v-text-field :disabled="editedIndex > -1 || !viewingToday" label="Fuel" v-model="editedItem.fuel"
                type="number" suffix="gal"></v-text-field>
            </fieldset>
            <v-text-field label="Squawks" v-model="editedItem.squawks"></v-text-field>

          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
            <v-btn color="blue darken-1" type="submit" :disabled="!valid">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </section>
</template>

<style>
/*.stock em { text-transform: capitalize }*/
</style>
<script>
import { mapState } from 'vuex'



export default {



  data() {


    return {

      headers: [
        { text: "Aircraft", align: 'left', value: "name", sortable: false },
        { text: "Hobbs", align: 'left', value: "hobbs", sortable: false },
        { text: "Tachtime", align: 'left', value: "tachtime", sortable: false },
        { text: "Oil", align: 'left', value: "oil", sortable: false },
        { text: "Fuel", align: 'left', value: "fuel", sortable: false },
        { text: "Squawks", align: 'left', value: "squawks", sortable: false },
        { text: " ", align: 'left', value: "actions", sortable: false },
      ],


      stockHeaders: [

        { text: "", align: 'left', value: "name", sortable: false },
        { text: "", align: 'left', value: "qty", sortable: false },
        { text: " ", align: 'left', value: "actions", sortable: false },

      ],


      req: [v => !!(v && v.length) || 'Item is required'],

      dialog: false,
      valid: false,
      editedIndex: -1,

      editedItem: {
        hobbs: 0,
        tachtime: 0,
        oil: 0,
        fuel: 0,
        squawks: '',
        plain_id: null
      },

      resourceIndex: -1,

      editedResource: {

        qty: '',
        resource_id: 0,
      }


    }
  },

  f() {

  },


  computed: {

    ...mapState(['plain_logs']),
    ...mapState(['resources']),


    formTitle() {
      return this.editedIndex === -1 ? 'Log Aircraft Info' : 'Edit Aircraft Info'
    },

    currentDate() {
      return this.$store.state.currentDate
    },

    viewingToday() {
      return this.$store.state.isToday
    }

  },


  watch: {
    dialog(val) {
      val || this.close()
    },
  },


  methods: {

    addResources(item) {


      var qty = prompt('Enter amount', 0)

      if (qty) {

        // this.resourceIndex = this.resources.indexOf(item)
        // this.editedResource = Object.assign({}, item)

        this.editedResource.qty = qty
        this.editedResource.resource_id = item.id

        axios.post('/api/resource_logs', this.editedResource)
          .then(response => {

            this.$store.dispatch('fetchResources')

          })
      } else {
        console.log("Canceled by user");
      }


    },

    edit(item) {

      this.editedIndex = this.plain_logs.indexOf(item)
      this.editedItem = Object.assign({}, item)

      this.dialog = true
    },

    logInfo(item) {



      this.editedItem.plain_id = item.plainID
      this.dialog = true

    },

    close() {
      this.dialog = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1

      })
    },


    save() {

      this.editedItem.loadDate = this.currentDate

      if (this.editedIndex > -1) {
        axios.put('/api/aircraft_logs/' + this.editedItem.logID, this.editedItem)

          .then(response => {

            Object.assign(this.plain_logs[this.editedIndex], this.editedItem)

            this.close();

          })
          .catch(err => {
            console.log(err)
          })


      } else {


        axios.post('/api/aircraft_logs', this.editedItem)
          .then(response => {

            this.$store.dispatch('fetchPlainReportbyDate', this.currentDate)

            this.close();

          })
          .catch(err => {
            console.log(err)
          })

      }

    },


  }
}
</script>
